'use strict';

import { HotbarComponentResultSetAbstract } from 'hotdamnbar/resultSets';

class HotbarSelectResultSet extends HotbarComponentResultSetAbstract {}

export default HotbarSelectResultSet;